module.exports = __webpack_public_path__ + "img/trackd-icon-colours.ccb3f5f9.svg";